import { useEffect, useState } from "react";
import "../../css/toast.css";

const CommonModal = ({
  open,
  setOpen = () => {},
  title,
  onChangeModalState = () => {},
  children,
  width,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setOpen(false);
    onChangeModalState(false);
  };
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <div>
      <div style={{ display: isOpen ? "block" : "none" }} id="modal">
        <div id="modalwin" style={{ maxWidth: width, minWidth: width }}>
          <div id="modalhead">
            <span>{title}</span>
            <button id="modalclose" onClick={() => closeModal()}>
              &times;
            </button>
          </div>
          <div id="modalsec">
            <div id="modaltable">{children}</div>
          </div>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
